export const NASIYA_SETTINGS_PATH = '/nasiya-settings'

export const MONTH_MIN = 1
export const MONTH_MAX = 60
export const RATE_MIN = 0
export const RATE_MAX = 500

export const MONTH_PRESETS = [3, 6, 8, 12, 18, 24]
export const MONTH_OTHER = 'other'

export const formatRate = (rate) => {
	const n = Number(rate)
	if (!Number.isFinite(n)) return '-'
	return `${parseFloat(n.toFixed(3))}%`
}

export const settingsCountLabel = (count) =>
	count > 0 ? `${count} ta muddat` : 'sozlanmagan'
